import { EditableReturnProductType } from "@redotech/redo-model/return";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const updateProductReturn = {
  name: "updateProductReturn" as const,
  input: z.object({
    returnId: zExt.objectId(),
    productId: zExt.objectId(),
    newType: z.enum(EditableReturnProductType).optional(),
    newValue: z.number().optional(),
    note: z.string().optional(),
    merchantImages: z.array(z.string()).nullish(),
    customItemTitle: z.string().min(1).optional(),
    // Non-negative money amount. Decimal-place enforcement happens in the
    // handler since Zod can't reliably check decimal precision on floats.
    customItemPrice: z.number().nonnegative().finite().optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
